enum UN_ICONS_TYPOGRAPHY_VARIANT {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H6 = 'h6',
  SUBTITLE1 = 'subtitle1',
  SUBTITLE2 = 'subtitle2',
  BODY1 = 'body1',
  BODY2 = 'body2'
}

export default UN_ICONS_TYPOGRAPHY_VARIANT;
